<template lang="pug">
  .modal.modal--sm
    button.modal__close(
    @click="$emit('close')"
    )
      img(src="@/assets/images/icons/cross.svg")
    h2.modal__title Подача заявки
    p.modal__text Для подачи заявки необходимо наличие портфолио
    .modal__button
      button.button.button_paint-main.button_full(
      @click.prevent="$router.push({name: 'user-profile', query: { section: 'portfolio' }})"
      )
        .button__text Добавьте портфолио
</template>
<script>
export default {
  name: "add-portfolio",
  data() {
    return {};
  },
};
</script>
